<template>
  <div class="kompa-product-create-view">
    <h1>{{$t('titles.create')}}</h1>

    <kompa-product-form @submit="insertKompaProduct"
                :model="kompaProduct"
                :errors="errors"
                :disabled="isSubmitting" />
  </div>
</template>

<script>
import KompaProductForm from '@/components/KompaProductForm';
import insertKompaProductQuery
  from '@/api/mutations/create-kompa-product.graphql';
import View from '@/mixins/View';
import Submittable from '@/mixins/Submittable';
import Toast from '@/helpers/Toast';

export default {
  name: 'kompa-product-create-view',
  mixins: [
    Submittable,
    View,
  ],
  components: {
    KompaProductForm,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    breadcrumbs() {
      return [
        {
          key: 'edit',
          route: {
            name: 'edit-kompa-product',
            params: {},
          },
        },
      ];
    },
  },
  apollo: {
  },
  methods: {
    async insertKompaProduct(kompaProduct) {
      kompaProduct.attachments = (kompaProduct.attachments || [])
        // ESLint has conflicting rules - we shall use the property shorthand,
        // but also a return - which is incompatible
        // eslint-disable-next-line arrow-body-style
        .map(({ id, isHeroImage }) => {
          return { id, isHeroImage };
        });
      const operation = await this.submitWithMutation({
        mutation: insertKompaProductQuery,
        variables: { kompaProduct },
      });
      if (operation.isValid) {
        const name = operation.kompaProduct.name;
        const message = this.$t('toasts.created', { name });
        Toast.success(message);
        this.$router.push({
          name: 'edit-kompa-product',
          params: { id: operation.kompaProduct.id },
        });
      }
    },
  },
  i18n: {
    messages: {
      de: {
        titles: {
          create: 'Kompa Produkt anlegen',
        },
        toasts: {
          created: 'Kompa Product angelegt: {name}',
        },
      },
    },

  },
};
</script>



// WEBPACK FOOTER //
// CreateKompaProductView.vue?62ff559d